import { IEntry } from './base';

export const FirearmTypes = {
  Rifle: 'Rifle',
  Shotgun: 'Shotgun',
  Handgun: 'Handgun',
  Revolver: 'Revolver',
  Pistol: 'Pistol',
  'Machine Gun': 'Machine Gun',
} as const;

export interface IFirearmModel extends IEntry {
  make: IEntry;
}

export interface IFirearm {
  type?: keyof typeof FirearmTypes;
  make?: IEntry;
  model?: IFirearmModel;
}
